import {
    QUOTATIONS_UPDATE,
    QUOTATIONS_UPDATE_UUID,
    QUOTATIONS_UPDATE_TOTAL,
    QUOTATIONS_UPDATE_OPTION,
    QUOTATIONS_UPDATE_SELECTED_QUOTATION,
    QUOTATIONS_UPDATE_SELECTED_IMPIANTO,
    STORE_RESET
} from '../../actions/action-types';
import appInitialState from '../../store/appInitialState';

const dotProp = require('dot-prop-immutable');

const initialState = appInitialState.quotations;

/**
 * This is the application state's quotations slice reducer
 *
 * @param {Object} state 
 * @param {Object} action
 * 
 * @usages
 *  ...
 */
function quotationsReducer(state = initialState, action) {

    let dataPath = '';

    switch(true) {

        case (action.type === STORE_RESET):
            
            state = {
                ...state,
                ...initialState
            };
            break;

        case (action.type === QUOTATIONS_UPDATE):

            state = action.payload.quotations;
            break;

        case (action.type === QUOTATIONS_UPDATE_UUID):

            dataPath = 'uuid';
            state = dotProp.set(state, dataPath, action.payload.uuid);
            break;

        case (action.type === QUOTATIONS_UPDATE_TOTAL):

            dataPath = `${action.payload.quotationType}.total`;
            state = dotProp.set(state, dataPath, action.payload.totalValue);
            break;

        case (action.type === QUOTATIONS_UPDATE_OPTION):

            dataPath = `${action.payload.quotationType}.options.${action.payload.optionId}`;
            state = dotProp.set(state, dataPath, action.payload.optionValue);
            break;

        case (action.type === QUOTATIONS_UPDATE_SELECTED_QUOTATION):

            dataPath = 'selectedQuotation';
            state = dotProp.set(state, dataPath, action.payload.quotationType);
            break;

        case (action.type === QUOTATIONS_UPDATE_SELECTED_IMPIANTO):

            dataPath = 'selectedImpianto';
            state = dotProp.set(state, dataPath, action.payload.impianto);
            break;

        default:
            
    }

    return state;
};

export default quotationsReducer;